import { SortState } from "@redotech/redo-return-ui/flows/return-flow/sort";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SortDetails = memo(function SortDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<SortState>) {
  return (
    <Flex dir="column" gap="md">
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Destination
        </Text>
        <RedoTextInput
          placeholder="Sort destination"
          setValue={(destination) =>
            setState((state) => ({ ...state, destination }))
          }
          value={state.destination}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          Where the warehouse worker should route the unit (e.g. a bin label).
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Next step (optional)
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
      </Flex>
    </Flex>
  );
});
